import _regeneratorRuntime from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/regenerator";
import _createForOfIteratorHelper from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Ak_PC\\Documents\\GitHub\\DevAkhil.github.io\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { getLinkColor, getLinkRandomColor } from "../../../Utils/ColorUtils";
import { Constants } from "../../../Core/Utils/Constants";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
import { getDistance } from "../../../Utils/NumberUtils";
import { isInArray } from "../../../Utils/Utils";
export var Grabber = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Grabber, _ExternalInteractorBa);

  var _super = _createSuper(Grabber);

  function Grabber(container) {
    _classCallCheck(this, Grabber);

    return _super.call(this, container);
  }

  _createClass(Grabber, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          mouse = container.interactivity.mouse,
          events = container.actualOptions.interactivity.events;
      return events.onHover.enable && !!mouse.position && isInArray("grab", events.onHover.mode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _a, container, options, interactivity, mousePos, distance, query, _iterator, _step, particle, pos, pointDistance, grabLineOptions, lineOpacity, opacityLine, optColor, linksOptions, colorLine;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = this.container, options = container.actualOptions, interactivity = options.interactivity;

                if (!(!interactivity.events.onHover.enable || container.interactivity.status !== Constants.mouseMoveEvent)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                mousePos = container.interactivity.mouse.position;

                if (mousePos) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                distance = container.retina.grabModeDistance, query = container.particles.quadTree.queryCircle(mousePos, distance);
                _iterator = _createForOfIteratorHelper(query);
                _context.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context.next = 26;
                  break;
                }

                particle = _step.value;
                pos = particle.getPosition(), pointDistance = getDistance(pos, mousePos);

                if (!(pointDistance > distance)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("continue", 24);

              case 15:
                grabLineOptions = interactivity.modes.grab.links, lineOpacity = grabLineOptions.opacity, opacityLine = lineOpacity - pointDistance * lineOpacity / distance;

                if (!(opacityLine <= 0)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("continue", 24);

              case 18:
                optColor = (_a = grabLineOptions.color) !== null && _a !== void 0 ? _a : particle.options.links.color;

                if (!container.particles.grabLineColor) {
                  linksOptions = options.interactivity.modes.grab.links;
                  container.particles.grabLineColor = getLinkRandomColor(optColor, linksOptions.blink, linksOptions.consent);
                }

                colorLine = getLinkColor(particle, undefined, container.particles.grabLineColor);

                if (colorLine) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("return");

              case 23:
                container.canvas.drawGrabLine(particle, colorLine, opacityLine, mousePos);

              case 24:
                _context.next = 10;
                break;

              case 26:
                _context.next = 31;
                break;

              case 28:
                _context.prev = 28;
                _context.t0 = _context["catch"](8);

                _iterator.e(_context.t0);

              case 31:
                _context.prev = 31;

                _iterator.f();

                return _context.finish(31);

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 28, 31, 34]]);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }]);

  return Grabber;
}(ExternalInteractorBase);